import { render, staticRenderFns } from "./FooterData.vue?vue&type=template&id=3b76a1e6"
import script from "./FooterData.vue?vue&type=script&lang=ts"
export * from "./FooterData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ResultsCardFooterSingleItem: require('/usr/src/nuxt-app/components/results/card/FooterSingleItem.vue').default})
